module.exports = __webpack_public_path__ + "img/105029.825ca708.png";